import { IProduct } from 'interfaces/products';
import { PRODUCTABLE_TYPES } from 'constants/admin/products';

export const getProductableTypeTranslation = (product: IProduct) => {
  return PRODUCTABLE_TYPES.find(type => type.value === product.productable_type)
    ?.label;
};
